import { ChangeEvent, FC } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { ResultAsync } from 'store/result/resultAsync';
import { getParams } from 'store/result/resultSelectors';
// Components
import Sidebar from 'components/Sidebar';
import { Select } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';

const NamespacesSort:FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  
  const params = useAppSelector(getParams);

  const handleChange = (event:ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    const key = name === 'key' ? value : params.key;
    const direction = name === 'key' ? params.key : value;
    dispatch(ResultAsync.fetchResultList({
      ...params,
      offset: 0,
      key,
      direction
    }));
  }

  return (
    <Sidebar>
      <Select
        label={t('labels.sortBy')} id="sortBy" name="key" value={params.key}
        onChange={handleChange}
        options={[
          { value: 'user.name', label: t('labels.firstName') },
          { value: 'user.surname', label: t('labels.lastName') },
          { value: 'user.username', label: t('labels.username') },
          { value: 'user.email', label: t('labels.email') },
          { value: 'score', label: t('labels.score') },
          { value: 'createdAt', label: t('labels.dateCreated') }
        ]}
      />
      <Select
        label={t('labels.direction')} id="direction" name="direction" value={params.direction}
        onChange={handleChange}
        options={[
          { value: 'asc', label: t('labels.ascending') },
          { value: 'desc', label: t('labels.descending') },
        ]}
      />
    </Sidebar>
  )
}

export default NamespacesSort;
